<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 雁阵系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>推送记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.platformId" placeholder="请选择平台名称" filterable>
					<el-option key="" label="请选择平台名称" value=""></el-option>
					<el-option v-for="item in platformKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;
				<el-select v-model="query.publishType" placeholder="请选择推送类型">
					<el-option key="" label="请选择推送类型" value=""></el-option>
					<el-option key="0" label="产品系列" value="0"></el-option>
					<el-option key="1" label="产品型号" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择推送状态">
					<el-option key="" label="请选择推送状态" value=""></el-option>
					<el-option key="0" label="准备推送" value="0"></el-option>
					<el-option key="1" label="推送成功" value="1"></el-option>
					<el-option key="2" label="推送失败" value="2"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				@selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="platformId" label="平台名称" :formatter="platformFormat" width="120"></el-table-column>
				<el-table-column prop="platformUserName" label="账号" width="120"></el-table-column>
				<el-table-column prop="publishType" label="发布类型" width="90">
					<template slot-scope="scope">
                        {{scope.row.publishType == 0?"产品系列":"产品型号"}}
                    </template>
				</el-table-column>
				<el-table-column prop="title" label="推送标题"></el-table-column>
				<el-table-column prop="status" label="状态" width="90">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.status == 0?'info':(scope.row.status == 1?'success':'danger')" >
                        {{scope.row.status == 0?"准备推送":(scope.row.status == 1?"推送成功":"推送失败")}}
						</el-tag>
                    </template>
				</el-table-column>
				<el-table-column prop="remark" label="说明"></el-table-column>
				<el-table-column prop="publishTime" label="推送时间" width="160"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >查看内容</el-button>
						<el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleBind"
					v-if="controll['bind']"
                >绑定记录</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleInit"
					v-if="controll['init']"
                >初始化失败记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

		<el-dialog v-dialogDrag :close-on-click-modal=false title="绑定推送记录" :visible.sync="bindVisible" width=70%>
            <el-form ref="form" :model="form" style="height:480px">
				<el-row>
					<el-col :span="7">
						<el-tree
						  :data="platformUserInfo"
						  node-key="id"
						  ref = "platformUserInfoRef"
						  default-expand-all
						  highlight-current
						  style="border:1px solid #eee; width:100%; padding-top:5px; height:475px; overflow:scroll"
						  @node-click="nodeClick">
						  <div slot-scope="{ node, data }" style="width:100%;">
							<div @dblclick="nodeDblclick(data)" style="width:100%;">{{ node.label }}</div>
						  </div>
						</el-tree>
					</el-col>
					<el-col :span="17" style="padding-left:20px">
						<el-row style="width:100%">
							<el-col :span="24">
								<el-select v-model="form.publishType" placeholder="请选择推送类型" @change="onChangePublishType">
									<el-option key="" label="请选择推送类型" value=""></el-option>
									<el-option :key=0 label="产品系列" :value=0></el-option>
									<el-option :key=1 label="产品型号" :value=1></el-option>
								</el-select>&nbsp;
								<el-select v-model="form.typeId" placeholder="请选择产品类型" @change="onChangeTypeId">
									<el-option key="" label="请选择产品类型" value=""></el-option>
									<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
								</el-select>&nbsp;
								<el-select v-model="form.productSeriesId" placeholder="请选择产品系列" filterable v-if = "form.publishType == 1" @change="onChangeProductSeriesId">
									<el-option key="" label="请选择产品系列" value=""></el-option>
									<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
								</el-select>
							</el-col>
						</el-row>
						<el-tree
						  :data="contentInfo"
						  ref = "contentInfoRef"
						  node-key="id"
						  show-checkbox
						  default-expand-all
						  style="border:1px solid #eee; margin-top:20px;width:100%; height:425px; overflow:scroll"
						  @check="handleCheck">
						</el-tree>
					</el-col>
				</el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bind">绑定</el-button>
                <el-button @click="bindVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
		
		
        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="showVisible" fullscreen>
            <el-form ref="form" :model="form">
				<el-tabs v-model= "activeName" type="card">
					<el-tab-pane label="描述" name="baseTab" v-if="form.productId == undefined">
						<div v-html= "form.baseInfo" style="min-height:499px"></div>
					</el-tab-pane>
					<el-tab-pane label="用途" name="purposeTab" v-if="form.productId == undefined">
						<div v-html= "form.purposeInfo" style="min-height:499px"></div>
					</el-tab-pane>
					<el-tab-pane label="分类" name="categoryTab" v-if="form.productId == undefined">
						<div v-html= "form.categoryInfo" style="min-height:499px"></div>
					</el-tab-pane>
					<el-tab-pane label="规格" name="specificationsTab" v-if="form.productId == undefined">
						<div v-html= "form.specificationsInfo" style="min-height:499px"></div>
					</el-tab-pane>
					<el-tab-pane label="尺寸" name="sizeTab" v-if="form.productId == undefined">
						<div v-html= "form.sizeInfo" style="min-height:499px"></div>
					</el-tab-pane>
					<el-tab-pane label="参数" name="paramTab" v-if="form.productId">
						<div v-html= "form.paramInfo" style="min-height:499px"></div>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
		
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPromotionRecordData, savePromotionRecord, deletePromotionRecord, getPromotionRecord, getPromotionPlatformKV, getPromotionContent, 
promotionRecordBind, getPlatformUserInfo, getContentInfo, getEnumValueKV, getProductSeriesKV, initPromotionRecord } from '../../../api/index';
export default {
    name: 'promotion-record',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            showVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
                platformId: [{ required: true, message: '请选择平台', trigger: 'blur' }],
				loginType: [{ required: true, message: '请选择登录类型', trigger: 'blur' }],
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
            },
			platformKV:[],
			activeName:"",
			showCode:false,
			platformUserInfo:[],
			contentInfo:[],
			bindVisible:false,
			productSeriesKV:[],
			productTypeKV:[],
			productTypeEnumCode:1003,
			loadTree:false,
			multipleSelection:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("promotion-record");
		this.getPlatform();
		this.getProductType();
        this.getData();
    },
    methods: {
		// 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//获取平台信息
		getPlatform() {
			getPromotionPlatformKV().then(res => {
				if (res.code == 0 ) {
					this.platformKV = res.data;
				} else {
					this.$message.error(res.message);
				}
			})
		},
		platformFormat(row, column, cellValue){
			let index = this.platformKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.platformKV[index].value;
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPromotionRecordData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 查看操作
        handleShow(index, row) {
			this.title = "发布内容信息";
            getPromotionContent(row.contentId).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.activeName = (this.form.productId == undefined?"baseTab":"paramTab");
					this.showVisible = true;
				} else {
					this.$message.error(`获取内容信息失败！` + res.message);
				}
			})
        },
		// 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePromotionRecord([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 绑定记录
		handleBind() {
			this.platformUserInfo = [];
			this.contentInfo = [];
			this.$set(this.form, 'publishType', "");
			this.$set(this.form, 'typeId', "");
			this.$set(this.form, 'productSeriesId', "");
			this.productSeriesKV = [];
			if (this.$refs.platformUserInfoRef) {
				this.$refs.platformUserInfoRef.setCurrentKey(null);
			}
			getPlatformUserInfo().then(res => {
				if (res.code == 0 ) {
					this.platformUserInfo = res.data;
					this.bindVisible = true;
				} else {
					this.$message.error("加载平台用户信息失败");
				}
			});
		},
		// 初始化状态
		handleInit() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要初始化的失败记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要初始化选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					initPromotionRecord(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('初始化成功');
							this.getData();
						} else {
							this.$message.error(`初始化失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
		//批量删除
		delAllSelection() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePromotionRecord(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
		onChangePublishType(value) {
			this.$set(this.form, 'typeId', "");
			this.contentInfo = [];
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.$set(this.form, 'productSeriesId', "");
			this.productSeriesKV = [];
			this.contentInfo = [];
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
			
			if (this.form["publishType"] == 0) {
				getContentInfo(this.form).then(res => {
					if (res.code == 0 ) {
						this.contentInfo = res.data;
						setTimeout(this.treeSelectNode, 100);
					} else {
						this.$message.error("加载产品信息失败");
					}
				});
			}
		},
		//产品系列变更
		onChangeProductSeriesId(value) {
			getContentInfo(this.form).then(res => {
				if (res.code == 0 ) {
					this.contentInfo = res.data;
					setTimeout(this.treeSelectNode, 100);
				} else {
					this.$message.error("加载产品信息失败");
				}
			});
		},
		//绑定
		bind() {
			let data = []
			for (var i = 0; i < this.platformUserInfo.length; i++) {
				let children = this.platformUserInfo[i]["children"];
				for (var j = 0; j < children.length; j ++) {
					let item = {};
					item["platformId"] = this.platformUserInfo[i]["id"];
					item["platformUserId"] = children[j]["id"];
					item["publishType"] = children[j]["publishType"];
					let ids = [];
					let bindItems = children[j]["bindItems"];
					if (bindItems.length > children[j]["limit"]) {
						this.$message.error("平台：" + this.platformUserInfo[i]["label"].replace(/\([\s\S]+?\)/, "") 
						+ ", 用户：" + children[j]["name"] + " 绑定产品数量超过限制");
						return;
					}
					for (var k = 0; k < bindItems.length; k ++){
						ids.push(bindItems[k]["id"]);
					}
					item["promotionContentIds"] = ids;
					data.push(item);
				}
			}
			promotionRecordBind(data).then(res => {
				if (res.code == 0 ) {
					this.$message.success("绑定成功");
					this.bindVisible = false;
					this.getData();
				} else {
					this.$message.error("绑定失败");
				}
			});
		},
		//用户双击
		nodeDblclick(data) {
			this.contentInfo = [];
			if (data["isLeaf"]) {
				if (data["publishType"] != undefined){
					this.$set(this.form, "publishType", data["publishType"]);
				}
				if (data.bindItems != undefined) {
					let temp = [];
					for (var i = 0; i < data.bindItems.length; i++) {
						let item = {};
						item["id"] = data.bindItems[i]["id"];
						item["label"] = data.bindItems[i]["label"];
						item["isLeaf"] = data.bindItems[i]["isLeaf"];
						item["disabled"] = data.bindItems[i]["disabled"];
						temp.push(item);
					}
					if (temp.length > 0) {
						let parent = {};
						parent["id"] = 0;
						parent["label"] = "全部";
						parent["isLeaf"] = false;
						parent["disabled"] = false;
						parent["children"] = temp;
						this.contentInfo = [parent];
						setTimeout(this.treeSelectNode, 100);
					}
				}
			}
		},
		
		//变更用户
		nodeClick(data) {
			let userData = this.$refs.platformUserInfoRef.getCurrentNode();
			if (userData["isLeaf"]) {
				if (userData["publishType"] != undefined){
					if (this.form["publishType"] != userData["publishType"]) {
						this.form["typeId"] = "";
						this.onChangeTypeId(this.form["typeId"]);
					}
					this.$set(this.form, "publishType", userData["publishType"]);
				}
				this.treeSelectNode();
			}
		},
		
		//内容加载后选择已勾选部分
		treeSelectNode() {
			if (this.contentInfo.length == 0) {
				return;
			}
			this.initContentInfoTree();
			let userData = this.$refs.platformUserInfoRef.getCurrentNode();
			if (userData == undefined) {
				return;
			}

			if (userData["isLeaf"]) {
				if (userData.bindItems != undefined) {
					let items = [];
					let nodes = this.contentInfo[0].children;
					let index = -1;
					for (var i = 0; i < nodes.length; i++) {
						index = userData.bindItems.findIndex(item => item["id"] === nodes[i]["id"]);
						if (index > -1) {
							items.push(nodes[i]);
							if (userData.bindItems[index]["disabled"]) {
								this.$set(nodes[i], 'disabled', true);
							}
						}
					}
					this.$refs.contentInfoRef.setCheckedNodes(items);
				}
			}
		},
		//初始化内容树结构
		initContentInfoTree() {
			this.$refs.contentInfoRef.setCheckedNodes([]);
			let nodes = this.contentInfo[0].children;
			for (var i = 0; i < nodes.length; i++) {
				this.$set(nodes[i], 'disabled', false);
			}
		},
		//选中操作
		handleCheck(node, checkedNodes) {
			let userData = this.$refs.platformUserInfoRef.getCurrentNode();
			if (userData == undefined || userData["isLeaf"] == false) {
				this.$message.error("请选择平台用户");
				this.$refs.contentInfoRef.setCheckedNodes([]);
				return;
			}
			if (checkedNodes["checkedKeys"].length > 0) {
				if (userData.bindItems.length > 0 && userData["publishType"] != undefined && this.form["publishType"] != userData["publishType"]) {
					this.$message.error("不支持体系和型号混合发布，请先确认站点支持的发布类型");
					this.$refs.contentInfoRef.setCheckedNodes([]);
					return;
				} else {
					this.$set(userData, "publishType", this.form["publishType"]);
				}
			}
			//如果是叶子节点，执行单节点处理
			if (node["isLeaf"]) {
				this.nodeCheckOperate(userData, node, 0);
			} else {
				//点击非叶子节点
				let nodes = node["children"];
				//选中的keys比节点下元素少，要不就是全部不选，要么就是有不可更改选中节点
				if (checkedNodes["checkedKeys"].length < nodes.length) {
					for (var i = 0; i < nodes.length; i++) {
						this.nodeCheckOperate(userData, nodes[i], 1);
					}
				} else if (checkedNodes["checkedKeys"].length >= nodes.length){
					//选中keys大于节点下元素，说明全选
					for (var i = 0; i < nodes.length; i++) {
						this.nodeCheckOperate(userData, nodes[i], 2);
					}
				}
			}
			userData["label"] = userData["name"] + " (" + userData["bindItems"].length + ")"; 
		},
		
		//节点选择操作 operate：0-取反（有则清除，没有则添加），1-有则清除，没有则不操作，2-有则不操作，没有则添加
		nodeCheckOperate(userData, node, operateType) {
			//不可操作
			if (node["disabled"]) {
				return;
			}
			let start = 0;
			let end = userData.bindItems.length - 1;
			let index = undefined;
			if (userData.bindItems.length > 0) {
				if (userData.bindItems[start]["id"] === node["id"]) {
					if (operateType < 2) {
						userData.bindItems.splice(start, 1);
					}
					return;
				}
				if (userData.bindItems[end]["id"] === node["id"]) {
					
					if (operateType < 2) {
						userData.bindItems.splice(end, 1);
					}
					return;
				}
				if (userData.bindItems[start]["id"] < node["id"]) {
					index = start;
				} else if (userData.bindItems[end]["id"] > node["id"]) {
					index = end;
				}
				if (index == undefined) {
					while (start <= end) {
						index = Math.floor((start + end) / 2);
						if (userData.bindItems[index]["id"] === node["id"]) {
							if (operateType < 2) {
								userData.bindItems.splice(index, 1);
							}
							return;
						} else if (userData.bindItems[index]["id"] < node["id"]) {
							end = index - 1;
						} else {
							start = index + 1;
						}
					}
					index = userData.bindItems[index]["id"] > node["id"]?index + 1:index;
				}
			}
			
			if (operateType === 0 || operateType === 2) {
				let item = {};
				item["id"] = node["id"];
				item["label"] = node["label"];
				item["isLeaf"] = node["isLeaf"];
				item["disabled"] = node["disabled"];
				userData.bindItems.splice(index, 0, item);
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
